// Mock data za Obućar Tašner Laki

export const businessInfo = {
  name: "Obućar Tašner Laki",
  tagline: "Majstorska radionica za popravku obuće, tašni i kofera",
  phone: "062 173 1969",
  phoneRaw: "+381621731969",
  email: "Obucartasnerlaki@gmail.com",
  address: {
    street: "Bulevar kralja Aleksandra 194",
    city: "Zvezdara, Beograd",
    full: "Bulevar kralja Aleksandra 194, Zvezdara, Beograd"
  },
  workingHours: {
    weekdays: "Ponedeljak - Petak: 10:00 - 19:00",
    weekend: "Vikend: Neradimo"
  },
  logo: "/otl_logo.png"
};

export const statistics = {
  shoes: {
    count: "20,000+",
    label: "Popravki obuće"
  },
  bags: {
    count: "20,000+",
    label: "Popravki tašni"
  },
  suitcases: {
    count: "10,000+",
    label: "Popravki kofera"
  },
  experience: {
    count: "15+",
    label: "Godina iskustva"
  }
};

export const services = [
  {
    id: 1,
    title: "Popravka obuće",
    description: "Profesionalna popravka svih vrsta obuće - od zamene đonova i potpetica do šivenja i restauracije. Koristimo isključivo kvalitetne materijale.",
    icon: "ShoeIcon",
    image: "https://images.unsplash.com/photo-1529953717281-81a40b131119"
  },
  {
    id: 2,
    title: "Popravka tašni",
    description: "Restauracija i popravka svih vrsta tašni, ranaca i novčanika. Od zamene rajsferšlusa i kvaka do obnove kože i šivenja.",
    icon: "Briefcase",
    image: "https://images.unsplash.com/photo-1759478138700-276c3c2d9e59"
  },
  {
    id: 3,
    title: "Popravka kofera",
    description: "Popravka putnih kofera i torbi - točkići, ručke, brave, rajsferšlusi. Vraćamo funkcionalnost vašim putnim pratiteljima.",
    icon: "Luggage",
    image: "https://images.unsplash.com/photo-1647502191516-68a4f8c74ed4"
  },
  {
    id: 4,
    title: "Kožna galanterija",
    description: "Proizvodnja predmeta od kože po meri - kaiši, novčanici, futrole i ostali proizvodi od prirodne kože vrhunskog kvaliteta.",
    icon: "Package",
    image: "https://images.unsplash.com/photo-1775127730710-46450adcf73e"
  }
];

export const heroImage = "https://customer-assets.emergentagent.com/job_majstorska-radionica/artifacts/h425fcds_IMG_2902.jpg";

export const features = [
  {
    title: "Iskusni majstori",
    description: "Naš tim ima dugogodišnje iskustvo u radu sa svim vrstama materijala i proizvoda."
  },
  {
    title: "Kvalitetni materijali",
    description: "Koristimo samo proveren materijal vrhunskog kvaliteta za sve vrste popravki."
  },
  {
    title: "Brza usluga",
    description: "Većina popravki se obavlja u roku od 24-48h, hitne popravke istog dana."
  },
  {
    title: "Pristupačne cene",
    description: "Nudimo konkurentne cene uz garanciju kvaliteta i dugotrajnosti popravke."
  }
];

export const testimonials = [
  {
    name: "Marko P.",
    text: "Odlična usluga! Popravili su mi omiljene cipele koje nisam mogao da nosim godinu dana. Sada su kao nove!",
    rating: 5
  },
  {
    name: "Ana S.",
    text: "Profesionalci! Torba koju sam mislila da je nepopravljena sada izgleda fantastično. Preporučujem!",
    rating: 5
  },
  {
    name: "Jovana M.",
    text: "Brzo, kvalitetno i pristupačno. Moj kofer dobio novi život. Hvala!",
    rating: 5
  }
];
